import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30b7ca28")

_pushScopeId("data-v-30b7ca28")
const _hoisted_1 = { class: "d-flex justify-space-between pa-4" }
const _hoisted_2 = { class: "value" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "unit" }, "H", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "unit" }, "M", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4" }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, _toDisplayString(_ctx.$t("sleepTimeAnalyse.averageSleepDuration")), 1),
        _createVNode("div", _hoisted_2, [
          _createTextVNode(_toDisplayString($setup.duration($props.averageSleepTime).hours) + " ", 1 /* TEXT */),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString($setup.duration($props.averageSleepTime).minutes) + " ", 1 /* TEXT */),
          _hoisted_4
        ])
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_my_card_body, { class: "px-4" }, {
        default: _withId(() => [
          _createVNode("div", {
            ref: $setup.setRef,
            style: {"height":"60vw","width":"100%"}
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})